import { render } from "./base-card.vue?vue&type=template&id=5ddc3c52&scoped=true&ts=true"
import script from "./base-card.vue?vue&type=script&lang=ts"
export * from "./base-card.vue?vue&type=script&lang=ts"

import "./base-card.vue?vue&type=style&index=0&id=5ddc3c52&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\2\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ddc3c52"]])

export default __exports__